import React from "react";

export const Navigation = () => {
  return (
    <nav id="menu" className="navbar navbar-fixed-top optionquant-nav">
      <div className="container">
        {/* Brand + mobile toggle */}
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

         <a className="navbar-brand page-scroll" href="/">
  <span className="brand-o">O</span>
  <span className="brand-text">ption</span>
  <span className="brand-q">Q</span>
  <span className="brand-text">uaant</span>
</a>

        </div>

        {/* Navigation links */}
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
             <li><a href="/" className="page-scroll">About Us</a></li>
            <li><a href="/gallery" className="page-scroll">Gallery</a></li>
            <li><a href="/pricing" className="page-scroll">Pricing</a></li>
            <li><a href="#contact" className="page-scroll">Contact</a></li>
          
          </ul>
        </div>
      </div>
    </nav>
  );
};
